import {
  Box,
  Divider,
  Popover,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

import {
  getTableInputAnchorOrigin,
  getTableInputTransformOrigin,
} from "@components/data-table/utils";


const TableHeaderControl = ({
  onChange,
  label,
  active,
}: {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  active: boolean;
}) => {
  return (
    <Box>
      <Stack
        direction="row"
        justifyContent={"space-between"}
        alignItems="center"
        spacing={1}
        sx={{ width: "100%", p: 1 }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {label}
        </Typography>
        <Box>
          <Switch
            onChange={onChange}
            checked={active}
            color="primary"
            size="small"
          />
        </Box>
      </Stack>
      <Divider />
    </Box>
  );
};

export const TableSettingsMenu = ({
  onClose,
  anchor,
  keyOptions,
  keyLabels,
  hiddenColumns,
  addHiddenColumn,
  removeHiddenColumn,
  removeOptions,
}: {
  onClose: () => void;
  anchor: HTMLElement | null;
  keyOptions: string[] | null;
  keyLabels: Record<string, string>;
  hiddenColumns: string[] | null;
  addHiddenColumn: (key: string) => void;
  removeHiddenColumn: (key: string) => void;
  removeOptions?: string[];
}) => {
  const options = (keyOptions || []).filter((key) => !(removeOptions || []).includes(key));

  return (
    <Popover
      className="table-controls-popup"
      anchorOrigin={getTableInputAnchorOrigin()}
      transformOrigin={getTableInputTransformOrigin()}
      open={!!anchor}
      anchorEl={anchor}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          p: 1.5,
        },
      }}
    >
      {options?.map((key) => (
        <TableHeaderControl
          key={key}
          label={keyLabels[key] || key}
          active={!(hiddenColumns ?? []).includes(key)}
          onChange={() => {
            if ((hiddenColumns ?? []).includes(key)) {
              removeHiddenColumn(key);
            } else {
              addHiddenColumn(key);
            }
          }}
        />
      ))}
    </Popover>
  );
};
